import {
  BasisSchema,
  CatalogueYearSchema,
  DEFAULT_SELECTORS,
  type Selectors,
  TerritorySchema,
  TopNSchema,
} from '@dashboard/contract';
import { z } from 'zod';

/** Everything the page shows lives in the URL, so a link reproduces the view. */
export const SearchSchema = z.object({
  topN: TopNSchema.catch(DEFAULT_SELECTORS.topN),
  territory: TerritorySchema.catch(DEFAULT_SELECTORS.territory),
  cat: CatalogueYearSchema.catch(DEFAULT_SELECTORS.cat),
  basis: BasisSchema.catch(DEFAULT_SELECTORS.basis),
  ev: z.enum(['all', 'revival', 'campaign']).catch('all'),
  stack: z.enum(['abs', 'pct']).catch('abs'),
  peerSort: z.enum(['tot', 'cat', 'cagr']).catch('tot'),
  /** Comma-separated peer artist ids. */
  peers: z.string().optional().catch(undefined),
  peerSetId: z.string().optional().catch(undefined),
});
export type Search = z.infer<typeof SearchSchema>;

export function selectorsOf(s: Search): Selectors {
  return { topN: s.topN, territory: s.territory, cat: s.cat, basis: s.basis };
}

export function peerIds(s: Search): string[] {
  return s.peers ? s.peers.split(',').filter(Boolean) : [];
}
